import React from 'react';
import '../../style/css/h2homepage.css'


const H2Homepage = (props) => {
    return (
        <h2 className={'notif-title-container'}>
            <div className={'right-title'}>
                <div className={'notif-icon'}><img className={'icon-h2-homepage'} src={props.iconName}/></div>
                <span className={'notif-title'}>{props.title}</span>
            </div>
            <button>צפיה בהכל</button>
        </h2>
    );
};

export default H2Homepage;